import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Context/AuthContext";

const Text11 = () => {
  const { subscriptionData, usersData, subscriptionActiveStatus, isPremium } =
    useAuth();
  const [endDate, setEndDate] = useState();
  const [isSubscriptionCancelled, setIsSubscriptionCancelled] = useState(false);

  useEffect(() => {
    async function processSubscriptionData(subscriptionData) {
      if (subscriptionData) {
        Object.keys(subscriptionData).map(async (key) => {
          const seconds =
            subscriptionData[key].current_period_end.seconds * 1000;
          const dateObject = new Date(seconds).toLocaleString();
          setEndDate(dateObject);
          const subscriptionStatus = subscriptionData[key].cancel_at_period_end;
          setIsSubscriptionCancelled(subscriptionStatus);

          return null;
        });
      }
    }
    processSubscriptionData(subscriptionData);
  }, [subscriptionData]);
  return (
    <>
      <form>
        <label style={{ fontWeight: "bold" }}>Användare:</label>
        <div>{usersData.name}</div>
        <hr />
        <label style={{ fontWeight: "bold" }}>Mejl:</label>
        <div>{usersData.email}</div>
        <hr />
        <label style={{ fontWeight: "bold" }}>Nuvarande status:</label>
        <div
          style={{
            display: "flex",
            width: "25%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            {subscriptionActiveStatus && isPremium ? "Active" : "Inactive"}
          </div>
        </div>
        <hr />
        <label style={{ fontWeight: "bold" }}>Nuvarande period slutar:</label>
        <div>{endDate}</div>
        <hr />
        <label style={{ fontWeight: "bold" }}>Prenumerationstatus:</label>

        <div>
          {isSubscriptionCancelled
            ? "Prenumeration avslutas vid periodslut."
            : "Förnyas automatiskt"}
        </div>
        <hr />
      </form>
      <a
        rel="noreferrer"
        target="_blank"
        href="https://billing.stripe.com/p/login/dR6bMkegc5i77o4eUU" //link to cusomer portal
        style={{ textDecoration: "none" }}
      >
        <div className="button-product-subscription w-50">
          Ändra din prenumeration
        </div>
      </a>
    </>
  );
};
export default Text11;
